<template>
    <div class="gcmcn-settings">
        <!-- 140px to be aligned to its neighbour component (irds-container) -->
        <!-- this value will ne to be updated when we'll add the tabs on this view -->
        <global-view style="margin-top: 110px;margin-right: 40px;"></global-view>
        <div class="gcmcn-settings-right-part">
            <div class="to-entities">
                <router-link :to="{ name: 'dashboard' }">
                    <el-button type="text" icon="el-icon-arrow-left">ENTITIES</el-button>
                </router-link>
            </div>
            <div class="header">
                <div class="title">settings</div>
                <div>
                    <div class="filter-container">
                        <search-filter @new-value="searchFilter = $event"></search-filter>
                    </div>
                </div>
            </div>
            <el-button
                type="text"
                class="btn-switch-mode"
                :class="{ 'mode-selected': selectedMode === 'auto' }"
                @click="switchSettingMode('auto')"
            >
                AUTOMATIC RECEIVERS
            </el-button>
            <el-button
                type="text"
                class="btn-switch-mode"
                :class="{ 'mode-selected': selectedMode === 'manual' }"
                @click="switchSettingMode('manual')"
            >
                MANUAL RECEIVERS
            </el-button>

            <ns-loader
                ref="ns-loader"
                :toLoad="toLoad"
                @dataFetched="onDataFetched"
            >
                <div slot="loader" class="loading-feed">
                    <img src="../../../../static/img/white-loader.svg">
                </div>
                <template slot="content">
                    <template v-if="selectedMode === 'auto'">
                        <div class="subtitle">Details</div>
                        <div class="irds-container">

                            <div v-if="!additionalDataFetched" class="loading-feed">
                                <img src="../../../../static/img/white-loader.svg">
                            </div>
                            <template v-else-if="filteredIrds.length > 0">
                                <ird-setting
                                    v-for="ird in filteredIrds"
                                    :key="ird.uid"
                                    :ird="ird"
                                    :feeds="feeds"
                                    :configurations="configurations"
                                    :events="events"
                                    :events-by-entity="eventsByEntity"
                                    :entities="$store.getters.entities"
                                    :parameters="{}"

                                ></ird-setting>
                            </template>
                            <div v-else>
                                <div class="gcmcn-card-gradient no-ird" >
                                    No automatic ird
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else>
                        <el-button
                            type="primary"
                            class="gcmcn-primary-btn btn-create-manual-receiver"
                            @click="openModalAddManualReceiver"
                        >Add a manual receiver</el-button>
                        <template v-if="filteredManualIrds.length > 0">
                            <manual-receiver
                                v-for="receiver in filteredManualIrds"
                                :key="receiver.uid"
                                :receiver="receiver"
                                @manual-receiver-archived="triggerRefresh"
                                @edit-receiver="editManualReceiver"
                            ></manual-receiver>
                        </template>
                        <div v-else>
                            <div class="gcmcn-card-gradient no-ird" >
                                No manual receiver
                            </div>
                        </div>
                        <create-manual-receivers
                            ref="modal-create"
                            :manual-receivers="manualReceivers"
                            :manual-receiver="selectedManualReceiver"
                            :entity-uid="$store.getters.currentTaker.scopes.entity_uid"
                            :taker-uid="$store.getters.currentTaker.uid"
                            @reset-selected-receiver="resetSelectedReceiver"
                            @trigger-refresh="triggerRefresh"
                        ></create-manual-receivers>
                    </div>
                </template>
            </ns-loader>
        </div>
    </div>
</template>

<script>
import { IrdSetting, SearchFilter } from 'gcmcn-common';
import CreateManualReceivers from './modal-create-manual-receiver.vue';
import ManualReceiver from './manual-receiver.vue';
import GlobalView from '../Home/global-view.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';

export default {

    components: {
        IrdSetting,
        GlobalView,
        SearchFilter,
        NsLoader,
        ManualReceiver,
        CreateManualReceivers,
    },

    props: {

    },

    data (){
        return {
            selectedMode: 'auto',
            timeoutID: null,
            searchFilter: '',
            additionalDataFetched: false,
            feeds: null,
            configurations: null,
            manualReceivers: [],
            eventsByEntity: {},
            events: null,
            irds: null,
            selectedManualReceiver: null,
        };
    },

    computed: {
        toLoad () {
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                    },
                },
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        archived: false,
                    },
                },
                {
                    name: 'irds',
                    model: 'irds',
                    filters: {
                        c_resp_nested: true,
                        archived: false,
                    }
                },
                {
                    name: 'manualReceivers',
                    model: 'manualReceivers',
                    filters: {
                        archived: false,
                    },
                },
            ];
        },
        filteredIrds (){
            if(this.irds){
                let takerIrds = this.irds.filter((ird) => {
                    return ird.taker_uid === this.$store.getters.currentTaker.uid;
                });
                if(this.searchFilter === ''){
                    return takerIrds;
                }
                return takerIrds.filter((ird) => {
                    return ird.name.toLowerCase().includes(this.searchFilter.toLowerCase());
                });
            }
            return [];
        },
        filteredManualIrds (){
            if(this.manualReceivers){
                let takerManualReceivers = this.manualReceivers.filter((receiver) => {
                    return receiver.taker_uid === this.$store.getters.currentTaker.uid;
                });
                if(this.searchFilter === ''){
                    return takerManualReceivers;
                }
                return takerManualReceivers.filter((ird) => {
                    return ird.remote_id.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
                           ird.public_ip.includes(this.searchFilter) ;
                });
            }
            return [];
        },
    },

    mounted (){
        this.$store.commit('SET_CURRENT_ENTITY', null);
        this.fetchScopedEvents();
    },
    beforeDestroy (){
        clearTimeout(this.timeoutID);
    },
    methods: {
        triggerRefresh (){
            this.$refs['ns-loader'].triggerRefresh();
        },
        editManualReceiver(receiver){
            this.$set(this, 'selectedManualReceiver', receiver);
            this.openModalAddManualReceiver();
        },
        resetSelectedReceiver(){
            this.$set(this, 'selectedManualReceiver', null);
        },
        openModalAddManualReceiver (){
            this.$refs['modal-create'].open();
        },
        switchSettingMode (mode){
            this.selectedMode = mode;
        },
        onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'configurations', res.configurations);
            this.$set(this, 'irds', res.irds);
            this.$set(this, 'manualReceivers', res.manualReceivers);
        },

        async fetchScopedEvents (){
            let events = [];
            let eventsByEntity = {};
            for(let entity of this.$store.getters.entities){
                let scopedEvent = await this.$store.dispatch('remoteGet', {
                    url: 'event',
                    config: {
                        'X-Entity-Uid': entity.uid
                    }
                });
                events.push(...scopedEvent.data.results);
                eventsByEntity[entity.uid] = scopedEvent.data.results.map((event) => event.uid);
            }
            this.$set(this, 'events', events);
            this.$set(this, 'eventsByEntity', eventsByEntity);
            this.additionalDataFetched = true;
            this.timeoutID = setTimeout(() => {
                this.fetchScopedEvents();
            }, 30000);
        },
    },
};
</script>

<style lang="scss">
    .gcmcn-settings{
        margin-left: 140px;
        display: flex;

        .sub-title{
            font-size: 15px;
            span{
                font-size: 15px;
                font-weight: bold;
            }
        }

        .gcmcn-settings-right-part {
            color: #BBBBBB;
            flex-grow: 1;
            text-transform: uppercase;
            max-width: 680px;

            .no-ird{
                min-height: 400px;
                font-size: 18px;
                font-weight: bold;
            }
            .btn-create-manual-receiver{
                display: flex;
                margin-left: auto;
                margin-bottom: 20px;
                font-size: 12px !important;
                font-family: roboto-light;
                font-weight: normal;
                padding: 10px 15px !important;
            }
            .to-entities {
                margin-bottom: 10px;
                .el-button {
                    color: #BBBBBB !important;
                }
            }

            .btn-switch-mode{
                color: #bbb;
                font-family: roboto-light;
                border-bottom: 1px solid #bbb;
                font-size: 10px;
                padding-bottom: 3px;
                margin-bottom: 15px;
                &:focus{
                    color: #409EFF;
                }
            }
            .mode-selected{
                border-bottom: 1px solid #409EFF;
                color: #409EFF;
            }

            .header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .title {
                    font-family: "Roboto Light";
                    margin-bottom: 5px;
                    font-size: 30px;
                }
                .filter-container{
                    width: fit-content;
                    display: flex;
                    margin-bottom: 15px;
                    margin-left: auto;
                    & > *{
                        margin-right: 25px;
                    }
                    & > *:last-child{
                        margin-right: 0;
                    }
                }
            }

            .subtitle {
                flex-grow: 1;
                font-family: "Roboto";
                margin-bottom: 15px;
                font-size: 9px;
            }

            .irds-container{
                margin-top: 34px;
                height: calc(100vh - 200px);
                overflow-y: auto;
            }
            .loading-feed{
                background-color: #222;
                border-radius: 5px;
                height: 160px;
                display: flex;
                justify-content: center;
                align-items: center;

                img{
                    animation: rotating 2s linear infinite;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Settings/index.vue